import withStyles from "isomorphic-style-loader/lib/withStyles";
import React from "react";
import { Col, Row } from "reactstrap";
import s from "./stylesComponents.scss";
import ReactTable from "react-table";
import { getEmpleadoAsistencias } from "../../actions/employeesReport";
import { errorNotification } from "../../../utils/notifications";

interface Props {
  personaId: boolean;
  viewMode: boolean;
}

class ClubAccesos extends React.Component<Props> {
  state = {
    data: []
  };

  componentDidMount() {
    getEmpleadoAsistencias(this.props.personaId)
      .then(({ data }) => {
        this.setState({
          data
        });
      })
      .catch(err => {
        errorNotification("No se pudieron consultar los accesos");
        this.setState({
          data: []
        });
      });
  }

  render() {
    return (
      <div>
        <Row className="primaryTitle m-0 mt-3">
          <Col>
            <p className="m-0">Accesos a club</p>
          </Col>
        </Row>

        <div className="mt-3">
          {(this.state.data || []).map(socio => (
            <>
              <div className="mt-3">
                ({socio.idPersona}) {socio.persona}
              </div>
              <ReactTable
                key={socio.idPersona}
                className=" -striped -highlight"
                data={socio.asistencias || []}
                columns={[
                  {
                    Header: "Club",
                    id: "club",
                    accessor: "club"
                  },
                  {
                    Header: "Fecha",
                    id: "fechaFormat",
                    accessor: "fecha",
                    className: "text-center"
                  },
                  {
                    Header: "Hora",
                    id: "horaFormat",
                    accessor: "hora",
                    className: "text-center"
                  },
                  {
                    Header: "Tipo",
                    id: "tipo",
                    accessor: "tipo",
                    className: "text-center"
                  },
                  {
                    Header: "Mensaje",
                    id: "message",
                    accessor: "message"
                  }
                ]}
                sortable={false}
                resizable={false}
                pageSize={
                  socio.asistencias && socio.asistencias.length > 5
                    ? socio.asistencias.length
                    : 5
                }
                showPagination={false}
              />
            </>
          ))}
        </div>
      </div>
    );
  }
}

export default withStyles(s)(ClubAccesos);
